import axios from 'axios';
import QueryString from 'qs';
import { generateQueryParams } from 'utils/generateQueryParams';

export const PaymentsService = {
  async getCardPayments(page, perPage, filters, tribe_id) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
      tribe_id: tribe_id === 3 ? null : tribe_id,
    });

    const res = await axios.get('payments/v1/cardPayment/', {
      params,
      paramsSerializer: (params) => {
        return QueryString.stringify(params, { arrayFormat: 'repeat' });
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientPayments(page, perPage, filters, tribe_id) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
      tribe_id: tribe_id === 3 ? null : tribe_id,
    });

    const res = await axios.get('payments/v1/paymentRecord/', {
      params,
      paramsSerializer: (params) => {
        return QueryString.stringify(params, { arrayFormat: 'repeat' });
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getCardReversalPayments(page, filters, tribe_id, perPage = 10) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
      tribe_id: tribe_id === 3 ? null : tribe_id,
    });

    const res = await axios.get('payments/v1/cardPaymentReversal/', {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getBccPayments(page, filters, tribe_id, perPage = 10) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
      tribe_id: tribe_id === 3 ? null : tribe_id,
    });

    const res = await axios.get('payments/v1/paymentTaxRecords/', {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getCardPaymentsDetail(id) {
    const res = await axios.get(`/payments/v1/getDetailViewCP/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getCardPaymentsDetailV2(id) {
    const res = await axios.get(`/payments/v1/cardPayment/detail/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientPaymentsDetail(id) {
    const res = await axios.get(`/payments/v1/getDetailViewPR/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getCardReversalPaymentsDetail(id) {
    const res = await axios.get(`/payments/v1/getDetailViewRefund/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getBccPaymentsDetail(id) {
    const res = await axios.get(`payments/v1/getDetailViewPTR/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async generatePayment(data) {
    const res = await axios.post('payments/v1/paymentRecord/', data);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async issueInvoice(data) {
    const res = await axios.put('payments/v1/paymentRecord/', { data });

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async editClientPayment(data) {
    const res = await axios.put('/payments/v1/payments/user/update/', data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async cardPaymentRefund(data) {
    const res = await axios.post('payments/v1/cardPaymentReversal/', data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async generateKaspiPayment(data) {
    const res = await axios.post('payments/v1/cardPayment/send/', data);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },
};
